import { render, staticRenderFns } from "./IconMinusSmSolid.vue?vue&type=template&id=847f03e6"
import script from "./IconMinusSmSolid.vue?vue&type=script&lang=js"
export * from "./IconMinusSmSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports